import { format } from 'date-fns';
import { type Wellbeing } from 'types/wellbeing';

const getAdjacentTrainingDate = (
  selectedDate: Date,
  trainings: Record<string, Wellbeing>,
  direction: 'next' | 'previous'
): Date | undefined => {
  const sortedKeys = Object.keys(trainings).sort();
  const selectedKey = format(selectedDate, 'yyyy-MM-dd');
  const currentIndex = sortedKeys.indexOf(selectedKey);

  if (direction === 'next') {
    if (currentIndex === -1 || currentIndex === sortedKeys.length - 1) return undefined;
    return new Date(sortedKeys[currentIndex + 1]);
  }

  if (currentIndex <= 0) return undefined;
  return new Date(sortedKeys[currentIndex - 1]);
};

export const nextTrainingDate = (
  selectedDate: Date,
  trainings: Record<string, Wellbeing>
): Date | undefined => getAdjacentTrainingDate(selectedDate, trainings, 'next');

export const previousTrainingDate = (
  selectedDate: Date,
  trainings: Record<string, Wellbeing>
): Date | undefined => getAdjacentTrainingDate(selectedDate, trainings, 'previous');

export const firstTrainingDateInMonth = (
  monthView: Date,
  trainings: Record<string, Wellbeing>
): Date | undefined => {
  const targetYear = monthView.getFullYear();
  const targetMonth = monthView.getMonth();

  const matchingKey = Object.keys(trainings).find(dateKey => {
    const date = new Date(dateKey);
    return date.getFullYear() === targetYear && date.getMonth() === targetMonth;
  });

  return matchingKey ? new Date(matchingKey) : undefined;
};

export const filterTrainingsByCurrentYear = (
  trainingsList: Wellbeing[]
): Record<string, Wellbeing> => {
  const currentYear = new Date().getFullYear();

  return trainingsList.reduce<Record<string, Wellbeing>>((acc, training) => {
    if (!training.startTime) return acc;

    const startDate = new Date(training.startTime);
    if (startDate.getFullYear() !== currentYear) return acc;

    const dateKey = format(startDate, 'yyyy-MM-dd');
    acc[dateKey] = training;
    return acc;
  }, {});
};
